/**
 * adapty-event-review-labels — ADM-FIN-S010 队列/弹窗共用中文标签
 *
 * 错误码闭集 = 数据字典 60-订阅 §2.7 准入六码；非法码回退原文。
 */

import type {
  AdaptyEventReviewAdmissionKind,
  AdaptyEventReviewResolutionStatus,
} from '@novel-admin/shared';

export const RESOLUTION_STATUS_ZH: Record<AdaptyEventReviewResolutionStatus, string> = {
  OPEN: '待确认',
  ACKNOWLEDGED: '已确认',
};

export const ADMISSION_KIND_ZH: Record<AdaptyEventReviewAdmissionKind, string> = {
  TERMINAL: '终态',
  RECOVERABLE_AGED_OUT: '超期未愈',
};

export const ERROR_CODE_ZH: Record<string, string> = {
  permanent_invalid_user: '用户标识永久非法',
  permanent_unattributed: '永久无法归属',
  permanent_continuity_field_missing: '连续性字段缺失',
  // 同一 original_transaction_id 在兄弟行间撞号 —— 归属对象不唯一，置位即 terminal（不再重放）
  permanent_ambiguous_lineage: 'lineage 撞号歧义',
  user_adapty_link_missing: '用户映射缺失',
  product_metadata_missing: '产品元数据缺失',
};
